import React, { Component } from 'react';
import PropTypes from 'prop-types';
import LoadMoreButton from './LoadMoreButton';
import Pagination from './Pagination';
import TotalCounter from './TotalCounter';

export default class ListFooter extends Component {
  static defaultProps = {
    handleLoadMore: () => {
      alert('TODO');
    },
    handlePageClick: () => {
      alert('TODO');
    },
  };

  static propTypes = {
    handleLoadMore: PropTypes.func.isRequired,
    handlePageClick: PropTypes.func.isRequired,
    total: PropTypes.number.isRequired,
    pageSize: PropTypes.number.isRequired,
    currentPage: PropTypes.number.isRequired,
    counterLabel: PropTypes.string,
  };

  render() {
    const {
      counterLabel,
      handleLoadMore,
      handlePageClick,
      total,
      pageSize,
      currentPage,
    } = this.props;
    const pageCount = total / pageSize;
    return (
      <div className="content-info">
        {total && total > (currentPage * pageSize) ? (
          <LoadMoreButton
            className={currentPage >= pageCount ? 'hidden' : ''}
            handler={handleLoadMore}
          />
        ) : (
          ''
        )}
        {total && total > pageSize ? (
          <Pagination selectPage={currentPage} pageCount={pageCount} handlePageClick={handlePageClick} />
        ) : (
          ''
        )}
        <TotalCounter counterLabel={counterLabel} total={total} />
      </div>
    );
  }
}
